import React from "react";
import styled from "styled-components/macro";
import styles from "../Nav/nav.module.css";
import logo1 from "../../images/logo1.png";

const MonitorBox = ({ frameColor, size, logo, colorUnit }) => {
  size = 241;

  return (
    <Box>
      <DividerHorizontal />
      <Box style={{ flexDirection: "row" }}>
        <Wrapper frameColor={colorUnit || frameColor} size={size}>
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "flex-end",
            }}
          ></div>
          <ScreenWrapper>
            <img
              style={{ objectFit: "contain", width: "99%", height: "99%" }}
              className={styles.LolinkImg}
              src={logo || logo1}
              alt="logo"
            />
          </ScreenWrapper>
        </Wrapper>
        <DividerVertical size={size} />
      </Box>
    </Box>
  );
};

const Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const Wrapper = styled.div`
  width: 166px;
  height: ${({ size }) => size}px;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 2px 5px #bababa;
  position: relative;
  display: flex;
  border-radius: 2px;
  background-color: ${({ frameColor }) => frameColor};
`;

const ScreenWrapper = styled.div`
  width: 125px;
  height: 170px;
  align-items: center;
  justify-content: center;
  box-shadow: inset 1px 1px 10px #bababa;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-bottom: 30px;
  background-image: linear-gradient(to bottom, #ffffff, #d4d4d4);
`;

const DividerHorizontal = styled.div`
  width: 144px;
  height: 8px;
  background-image: linear-gradient(to bottom, #e9e9e9, #c2c2c2);
  align-self: center;
`;

const DividerVertical = styled.div`
  width: 8px;
  height: ${({ size }) => size - 20}px;
  background-image: linear-gradient(to bottom, #e9e9e9, #c2c2c2);
  align-self: center;
`;
export { MonitorBox };
